import React, {Component, PropTypes} from 'react';
import IconSVG from 'svg-inline-react'
import classnames from 'classnames'

import './Card.scss';

class Card extends Component {
    
    static propTypes = {
        svgPath: PropTypes.string,
        text: PropTypes.string,
        className: PropTypes.string,
    }
    
    static defaultProps = {
        svgPath: '',
        text: '',
        className: '',
    }
    
    render() {
        return (
            <div className="Card">
                <div className="Card-iconBox">
                    <IconSVG
                        className={classnames('Card-icon', this.props.className)}
                        src={require(`!svg-inline!../InstantBookingSpinner/${this.props.svgPath}`)}
                    />
                    <div className="Card-iconText">{this.props.text}</div>
                </div>
                <div className="Card-text">
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default Card



// WEBPACK FOOTER //
// ./client/components/InstantBookingFinalInfo/Card.js